// extracted by mini-css-extract-plugin
export default {"logo":"Loading_logo__Ggofk","rotateY":"Loading_rotateY__qP8U3"};